import APIEndpoints from './apiEndpoints'

export const releasePageSize = 40
export const maxDownloadConcurrency = 3 //How many downloads to be executed at the same time.
export const downloadZipperQueuryInterval = 5 * 1000 //seconds
export const defaultBitrate = 320
export const tokenExpiryThreshold = 15
export const playlistImageAnimationInterval = 2000
export const defaultPagesize = 15
export const maxPagesize = 10000
export const notificationDuration = 4000

export const telContact = 'tel:+1-866-992-9670'
export const aboutLink = 'https://www.plaympe.com'
export const supportLink = 'https://www.plaympe.com/support/'
export const privacyPolicyLink = 'https://www.plaympe.com/privacy/'

export const sampleSongUrl = 'https://www.kozco.com/tech/LRMonoPhase4.wav'

export default APIEndpoints
